/* global axios */
import ApiClient from './ApiClient';

// NB: do NOT name the per-bot URL helper `baseUrl` -- ApiClient's `get url()`
// getter calls `this.baseUrl()`, so overriding it here recurses infinitely.
class KnowledgeEnrichmentTurnSignalsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  scopedUrl(agentBotId) {
    return `${this.url}/${agentBotId}/knowledge_enrichment/turn_signals`;
  }

  index(agentBotId, { page = 1, status } = {}) {
    return axios.get(this.scopedUrl(agentBotId), { params: { page, status } });
  }

  dismiss(agentBotId, id) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/dismiss`);
  }

  accept(agentBotId, id) {
    return axios.post(`${this.scopedUrl(agentBotId)}/${id}/accept`);
  }
}

export default new KnowledgeEnrichmentTurnSignalsAPI();
